import { ChangeDetectorRef, OnInit } from '@angular/core';
import { Component } from '@angular/core';
import { LayoutService } from './service/app.layout.service';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-menu',
  templateUrl: './app.menu.component.html',
})
export class AppMenuComponent implements OnInit {
  model: any[] = [];

  constructor(
    public layoutService: LayoutService,
    private router: Router,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    this.setMenu();
  }

  private setMenu(): void {
    this.model = [
      {
        label: 'Menú Principal',
        items: [
          {
            label: 'Dashboard',
            icon: 'pi pi-fw pi-home',
            routerLink: ['/home'],
          },
        ],
      },
      {
        label: 'Gestión De Empleadores',
        items: [
          {
            label: 'Empleadores',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/pages/employer'],
          },
        ],
      },
      {
        label: 'Gestión De Empleado',
        items: [
          {
            label: 'Empleados',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/pages/employee'],
          },
        ],
      },
      {
        label: 'Gestión De Ocupación',
        items: [
          {
            label: 'Ocupaciones',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/pages/occupation'],
          },
        ],
      },
      {
        label: 'Gestión De Zonas',
        items: [
          {
            label: 'Zonas',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/pages/zone'],
          },
        ],
      },
      {
        label: 'Gestión De Ofertas',
        items: [
          {
            label: 'Ofertas Laborales',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/pages/job-post'],
          },
        ],
      },
      {
        label: 'Gestión De Permisos',
        items: [
          {
            label: 'Permisos',
            icon: 'pi pi-fw pi-users',
            routerLink: ['/pages/permission'],
          },
        ],
      },
    ];
    this.cdr.detectChanges();
  }

  navigateTo(route: string) {
    this.router.navigate([route]);
  }
}
